import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getMedicamentosPosologias(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("posologias/access/listarPosologias", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    salvaMedicamentosPosologias(context, dados) {
        return new Promise(resolve => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("posologias/access/salvarPosologias", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
    
};

export default {
    state,
    actions,
    mutations,
    getters
};